import { clsx } from 'clsx'

import { Space } from '@tribeplatform/gql-client/types'
import { IconEmoji } from '@tribeplatform/react-components/common/components'
import { Avatar, avatarSizeClasses } from '@tribeplatform/react-ui-kit/Avatar'

import type { StaticField } from '../../Views/types.js'
import { getEmoji, getMedia } from '../utils/index.js'

interface Props {
  field: StaticField
  space: Space
  highlighted: boolean
}
export const ListImage = ({ field, space, highlighted }: Props) => {
  const imageSource = field.settings?.bannerSource
  const mediaUrl = getMedia({
    source: imageSource,
    space,
    size: 'small',
  })
  const emojiText = getEmoji({
    source: imageSource,
    space,
  })

  if (mediaUrl || imageSource !== 'image') {
    return (
      <div className="shrink-0">
        <Avatar
          size={field.settings?.avatarSize ?? 'lg'}
          src={mediaUrl}
          name={space.name}
          rounded="md"
          className={clsx(
            highlighted && 'ring-2 ring-offset-surface ring-focused',
          )}
        />
      </div>
    )
  }

  return (
    <div
      className={clsx(
        'shrink-0 flex items-center justify-center',
        highlighted && 'ring-2 ring-offset-surface ring-focused rounded-md',
        avatarSizeClasses[field.settings?.avatarSize ?? 'lg'],
      )}
    >
      <IconEmoji text={emojiText} size={field.settings?.avatarSize ?? 'lg'} />
    </div>
  )
}
